<template lang="pug">
.grid-filter
  p.column-title {{ columnTitle }}
  ed-input(:placeholder='t("Search") + " " + columnTitle'
          v-model='text'
          search
          :ref="'input'"
  )
  ed-button.btn.btn-actionbar(@click='apply') {{ t("Apply") }}
</template>

<script>

import {i18n} from '@/lang/lang'

export default {
  data() {
    return {
      text: '',
      columnTitle: ''
    }
  },

  created() {
    this.columnTitle = this.params.colDef.headerName
  },

  methods: {
    t: (key) => i18n.t(key),

    getModel: function() {
      return {
        filter: this.text
      }
    },

    setModel: function(model) {
      if (model && model.filter) {
        this.text = model.filter
      }
      if (model === null) {
        this.text = ''
      }
    },

    isFilterActive: function() {
      return this.text !== null && this.text !== undefined && this.text !== ''
    },

    apply() {
      this.params.filterChangedCallback()
    }
  }
}

</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";
@import "~@/assets/sass/_form_fields.scss";

.form-control,
.form-group .form-control {
  @include form-field;
}

</style>



// WEBPACK FOOTER //
// text.vue?ae5c1f0c